
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertsWarningTwotone as ObiAlertsWarningTwotoneElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alerts-warning-twotone.js';
 
 
 

 
 export const ObiAlertsWarningTwotone = createComponent({
   react: React,
   tagName: 'obi-alerts-warning-twotone',
   elementClass: ObiAlertsWarningTwotoneElement,
   events: {
     
   }
  });
 
 